import {
  Menu,
  MenuSelectionDetails,
  Portal,
  Stack,
  Text,
} from "@chakra-ui/react";
import { ReactNode } from "react";

interface Item {
  text: string;
  key: string;
  description?: string;
  icon?: ReactNode;
  disabled?: boolean;
  onClick: () => void;
}
export const CustomMenu = ({
  children,
  items,
}: {
  children: ReactNode;
  items: Item[];
}) => {
  return (
    <Menu.Root
      onSelect={(details: MenuSelectionDetails) => {
        const item = items.find((i) => i.key === details.value);
        if (item) {
          item.onClick();
        }
      }}
    >
      <Menu.Trigger asChild>{children}</Menu.Trigger>
      <Portal>
        <Menu.Positioner>
          <Menu.Content fontSize={"sm"}>
            {items.map(({ text, icon, disabled, description, key }) => (
              <Menu.Item
                key={key}
                value={key}
                disabled={disabled}
                cursor={disabled ? "auto" : "pointer"}
              >
                {icon}
                <Stack gap={0}>
                  <Text textStyle={"label"}>
                    {text}
                  </Text>
                  {!!description && (
                    <Text fontSize="xs" opacity={0.8} maxW={"260px"}>
                      {description}
                    </Text>
                  )}
                </Stack>
              </Menu.Item>
            ))}
          </Menu.Content>
        </Menu.Positioner>
      </Portal>
    </Menu.Root>
  );
};
